import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useDependencies } from "./useDependencies";
import { useDocumentationArea } from "./useDocumentationArea";
import { DocumentationAreaNotFoundError } from "src/contexts/documentationArea/domain/errors/DocumentationAreaNotFoundError";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";

type UpdateActorFromActorTemplateIdInput = {
  actorId: ActorId;
  templateId: string;
};

export const useUpdateActorFromActorTemplateId = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();
  const { documentationArea } = useDocumentationArea();
  const { documentationAreaController } = useDependencies();

  if (!documentationArea) {
    throw new DocumentationAreaNotFoundError();
  }

  const { mutate, isPending, error, reset } = useMutation({
    mutationFn: ({ actorId, templateId }: UpdateActorFromActorTemplateIdInput) =>
      documentationAreaController.updateActorFromActorTemplateId(
        token,
        documentationArea.getId(),
        actorId,
        templateId,
      ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["DocumentationArea", documentationArea.getId()] });
      queryClient.invalidateQueries({
        queryKey: ["DocumentationAreaActorBasicData", documentationArea.getId(), variables.actorId],
      });
    },
  });

  return { updateActorFromActorTemplateId: mutate, isPending, error, reset };
};
